import { createSelector } from 'reselect';
import { NAME } from './constants';

export const getEntities = state => state.getIn([NAME, 'entities']);
export const getUI = state => state.getIn([NAME, 'ui']);
export const getApp = state => state.getIn([NAME, 'app']);

export const getActive = createSelector(
  getEntities,
  state => getApp(state).get('active'),
  (entities, active) => {
    return active && entities.has(active) ? entities.get(active) : undefined;
  }
);

export const search = createSelector(
  getEntities,
  state => getApp(state).get('search'),
  (entities, search) => {
    return entities.filter(client => {
      if (
        client
          .get('firstName')
          .toLowerCase()
          .indexOf(search.toLowerCase()) !== -1
      ) {
        return true;
      }

      if (
        client
          .get('lastName')
          .toLowerCase()
          .indexOf(search.toLowerCase()) !== -1
      ) {
        return true;
      }

      if (
        client
          .get('email')
          .toLowerCase()
          .indexOf(search.toLowerCase()) !== -1
      ) {
        return true;
      }

      if (client.get('phone').indexOf(search) !== -1) {
        return true;
      }

      return false;
    });
  }
);

export const searchOrdered = createSelector(search, clients =>
  clients.sortBy(
    client => `${client.get('firstName')} ${client.get('lastName')}`
  )
);



// WEBPACK FOOTER //
// ./src/modules/clients/selectors.js